import { ReactComponent as DocumentIconRed } from '../../assets/icons/document-icon-red.svg';
import { ReactComponent as DocumentIconSuccess } from '../../assets/icons/document-icon-success.svg';
import { ReactComponent as DocumentIconWarning } from '../../assets/icons/document-icon-warning.svg';
import { ReactComponent as DocumentIconWhite } from '../../assets/icons/document-icon-white.svg';
import { Document } from '../../models/models';

import { Fragment } from 'react/jsx-runtime';

const DocumentStatusIcon = ({ document }: { document: Document }) => {
    const getColorIcon = () => {
        let statusIcon: any = null;
        switch (document.status.key) {
            case 'active':
                statusIcon = <DocumentIconWhite />;
                break;
            case 'rejected':
                statusIcon = <DocumentIconRed />;
                break;
            case 'approved':
                statusIcon = <DocumentIconSuccess />;
                break;
            case 'replaced':
                statusIcon = <DocumentIconWarning />;
                break;
            default:
                return null;
        }
        return statusIcon;
    };
    return <Fragment>{getColorIcon()}</Fragment>;
};

export default DocumentStatusIcon;
